import { render, staticRenderFns } from "./LightDimmer.vue?vue&type=template&id=2b233fce&"
import script from "./LightDimmer.vue?vue&type=script&lang=ts&"
export * from "./LightDimmer.vue?vue&type=script&lang=ts&"
import style0 from "./LightDimmer.vue?vue&type=style&index=0&id=2b233fce&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports